import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import { vulnerabilityKeys } from "../../../../../api/queryKeys";
import LoadingIcon from "../../../../../components/LoadingIcon";
import { daysPastSince } from "../../../../../utils/timestamp";
import VulnerabilitiesTable from "../../../../posture/vulnerabilities/VulnerabilitiesTable";
import { topExposureDaysCalculate } from "../../../../posture/vulnerabilities/utils";

const VulnerabilitiesTabRisk = ({
  entityData,
  onRowClick,
  pageSizeOptionsOverride,
}) => {
  const { fetchVulnerabilitiesByEntityId } = useAPI();
  const [topExposureDays, setTopExposureDays] = useState(0);

  const {
    data: entityVulnerabilities,
    isLoading: entityVulnerabilitiesIsLoading,
  } = useQuery({
    queryKey: vulnerabilityKeys.vulnerabilitiesByEntityId(entityData.entity_id),
    queryFn: () => {
      return fetchVulnerabilitiesByEntityId(entityData.entity_id);
    },
    select: (response) =>
      response.data.map((vuln) => ({
        ...vuln,
        id: vuln.vulnerability_id,
        days_found: daysPastSince(
          vuln.published_date?.timestamp_utc_human_readable
        ),
      })),
    enabled: entityData !== null,
  });

  useEffect(() => {
    if (entityVulnerabilities) {
      setTopExposureDays(topExposureDaysCalculate(entityVulnerabilities));
    }
  }, [entityVulnerabilities]);

  return entityVulnerabilities?.length > 0 ? (
    <VulnerabilitiesTable
      dataIsLoading={entityVulnerabilitiesIsLoading}
      vulnerabilities={entityVulnerabilities}
      gridRef={null}
      onRowClick={(row) => onRowClick(row)}
      topExposureDays={topExposureDays}
      boxSXProps={{
        border: "none",
        width: "100%",
        ".MuiDataGrid-root": {
          border: "none",
          boxShadow: "none",
        },
        ".MuiDataGrid-main": {},
      }}
      filterColumns={[
        "vulnerability_id",
        "breeze_score",
        "severity",
        "exploit",
        "published_date",
      ]}
      pageSizeOptionsOverride={pageSizeOptionsOverride}
    />
  ) : entityVulnerabilitiesIsLoading ? (
    <LoadingIcon size={8} />
  ) : null;
};

export default VulnerabilitiesTabRisk;
